var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.042,
    height: 24.042,
    viewBox: "0 0 24.042 24.042",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_223",
    "data-name": "Group 223",
    transform: "translate(-1739.426 -1666.279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_233",
    "data-name": "Ellipse 233",
    transform: "translate(1751.447 1666.279) rotate(45)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.5,
    cy: 8.5,
    r: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_444",
    "data-name": "Rectangle 444",
    d: "M0,0H7A1,1,0,0,1,8,1V1A1,1,0,0,1,7,2H0A0,0,0,0,1,0,2V0A0,0,0,0,1,0,0Z",
    transform: "translate(1757.104 1683.25) rotate(45)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.8bdc953948496f86d485792780ec22c9.svg";
export { ForwardRef as ReactComponent };